import React from "react";
import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";

import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";

const { BRAND_NAME } = process.env;

const ProReview = () => {
	const classes = useStyles("Pro");
	const { review, review_bio, review_image } =
		useConstants("ProBannerViewModel");

	return (
		<React.Fragment>
			<Box
				component="section"
				className={classes.quoteWrapper}
				display={"flex"}
				alignItems={"center"}
				justifyContent={"center"}
				bgcolor={"grey.50"}
			>
				<Container maxWidth={false} className={classes.proContainer}>
					<Grid container spacing={8}>
						<Grid item xs={12} sm={6}>
							<Box
								display={"flex"}
								flexDirection={"column"}
								justifyContent={"center"}
								height={"100%"}
							>
								<div className={classes.quoteSymbol}>“</div>

								<div className={classes.quoteHead}>{review}</div>

								<Box mt={4}>{review_bio}</Box>
							</Box>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Box
								width={"100%"}
								height={"100%"}
								display={"inline-block"}
								borderRadius={4}
							>
								<Avatar
									variant="rounded"
									src={review_image}
									alt={review_bio}
									imgProps={{
										decoding: "async",
										loading: "lazy",
									}}
									style={{ width: "100%", height: "100%" }}
								/>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>
		</React.Fragment>
	);
};

ProReview.propTypes = {};
export default ProReview;
